/**
 *Created by jmmartinez on 3/8/18
 * v.1.1  22/03/2019 Añadido nivel, en constructor en elementosPorPagina puesto el props.
 * v.1.2  14/03/2019 Cuando solo hay una página. no mostrar paginador
 * v.1.3  02/06/2019 Creados tipos de paginacion
 *                   En render, cambiado criterio para mostrar paginador.
 * v.1.4  05/06/2019 Modificado el div wrapper con la propiedad height para que el scroll del grid sobrepase las 200 líneas.
 *                   (Anulada).
 * v.1.5  09/09/2019 Cambiado el constructor  con paginaActual: props.paginaActual
 * v.1.6  25/10/2019 Modificaciones para tener en cuenta loadedTodasPaginas
 * v.1.7  29/10/2019 Añadida propiedad showBuscador
 * v.1.8  30/10/2019 Añadida propiedad elementoSeleccionado, para reseleccionar un elemento al volver al grid.
 *                   Añadidas propiedades valorBuscador y onValorBuscadorCambiado.
 * v.1.9  11/11/2019 Añadidas propiedades editable y onRowModificado
 * v.1.10 02/03/2020 Añadido evento onNewRow para crear el elemento nuevo de la nueva fila.
 * v.1.11 06/03/2020 Añadida propiedad tipoGrid para elegir cual de los dos usamos.
 *                   En render se renderizan los dos tipos de grids.
 * v.1.12 16/03/2020 Eliminadas propiedades de modificacion en la llamada a Grid en render
 * v.1.13 20/03/2020 Añadidad prop. elementoConfig para poder automatizar la creación del nuevo elemento.
 * v.1.14 13/04/2020 Añadido el parametro ifid y usuarioCodigo al renderizar <Grid
 * v.1.15 15/04/2020 Añadida propiedad usuario.
 *                   Paso del usuario a Grid.
 * v.1.16 23/04/2020 Añadido parametro elementoSeleccionado en <GridRDG
 * v.1.17 27/04/2020 Añadida propiedad mostrarFilaActiva: PropTypes.bool,
 * v.1.18 01/05/2020 Añadido editable={editable} en llamada a <Grid
 * v.1.19 05/05/2020 Añadidas propiedades onRowModificada y onNewRow en la llamada a <Grid
 * v.1.20 24/07/2020 Añadido evento onDatosModificados.
 *                   Añadida pripiedad onDatosModificados en llamada a <Grid
 * v.1.21 28/09/2020 Soporte de gridRDG2
 * v.2.00 29/09/2020 Cambiado a framework2
 * v.2.1  01/10/2020 Corregido tipoGrid en propTypes
 * v.2.2  16/10/2020 Añadida propiedad estilizadorRow y se pasa a GridRDG
 * v.2.3  20/10/2020 Gestión de mostrarFilaActiva y paso correcto a GridRDG
 *
 *
 * v.2.4  22/11/2020 Añadida propiedad editable a <GridRDG
 * v.2.5  12/12/2020 Añadida propiedad estilo que se transmite a <GridRDG
 *
 * v.2.10 29/07/2021 Añadida propiedad urlServicioRestful y uso en GridRDG
 *                   Añadida propiedad usarFiltros35 y uso en GridRDG
 *                   Para poder usar la ref de GRidRDG
 * v.2.11 10/08/2021 Añadida propiedad funcRefreshData, un enlace a la función refreshData de FormularioGrid para provocar un refresco completo.
 *
 *
 * v.2.12 06/05/2022 Union Planifikator y Sidemur
 * v.2.13 07/06/2022 Añadido en la llamada a <GridRDG las variables:
 *                                  onValorBuscadorCambiado={onValorBuscadorCambiado}
 *                                   valorBuscador={valorBuscador}
 * v.2.14 08/06/2021 Se añade id como parámetro
 * v.2.15 24/04/2023 Añadida propiedad mostrarModificar y onModificar
 * v.2.16 25/04/2023 Añadida propiedad mostrarEliminar y onEliminar
 * v.2.17 13/07/2023 Añadida la propiedad desdeMovil: PropTypes.bool
 *                    Usada la propiedad desdeMovil en la llamada a <GridRDG
 *
 * v.2.18 28/07/2023 Añaddias propiedades mostrarChecksSeleccion y onSelectedRowsChanged.
 *                      Añadidas en la llamada a <GridRDG
 * */


import React from 'react'

import PropTypes from 'prop-types';
import Grid from "../../blueprint/Grid"
import GridRDG from "../../adazzle/GridRDG"
import '../../resources/css/pagination.css';
import ReactPaginate from 'react-paginate';
import {Icon, Intent, Spinner, Tab} from "@blueprintjs/core";


export const PAGINACIONTIPO_SIN = 'PAGINACIONTIPO_SIN';
export const PAGINACIONTIPO_NORMAL = 'PAGINACIONTIPO_NORMAL';
export const PAGINACIONTIPO_PAGINAUNICA = 'PAGINACIONTIPO_PAGINAUNICA';
export const PAGINACIONTIPO_PAGINAUNICASCROLL = 'PAGINACIONTIPO_PAGINAUNICASCROLL';

class GridPaginado extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            datos: [],
            selectedRow: -1,
            elementosPorPagina: props.elementosPorPagina,
            numPaginas:1,
            cargandoDatos: false,
            paginaActual: props.paginaActual,
        }
        this.refGrid = React.createRef();
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if(nextProps.datos !== prevState.datosIniciales){
            newState.datos= nextProps.datos;
        }

        if(nextProps.elementosPorPagina !== prevState.elementosPorPagina){
            newState.elementosPorPagina= nextProps.elementosPorPagina;
        }

        if (nextProps.numPaginas !== prevState.numPaginas) {
            newState.numPaginas = nextProps.numPaginas;
        }
        if (nextProps.cargandoDatos !== prevState.cargandoDatos) {
            newState.cargandoDatos = nextProps.cargandoDatos;
        }

        if (nextProps.listasElementosCombos !== prevState.listasElementosCombos) {
            newState.listasElementosCombos = nextProps.listasElementosCombos;
        }

        if (nextProps.cargandoListasElementosCombos !== prevState.cargandoListasElementosCombos) {
            newState.cargandoListasElementosCombos = nextProps.cargandoListasElementosCombos;
        }


        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    handlePageClick = data => {
        const {elementosPorPagina, paginaActual} = this.state;
        const {onPageChanged} = this.props;

        let selected = data.selected;
        if (paginaActual !== selected) {
            let offset = Math.ceil(selected * elementosPorPagina);
            this.setState({paginaActual: selected});
            onPageChanged && onPageChanged(offset, selected);
        }
    };

    configurarGrid = () => {
        this.refGrid.current.configurar();
    }

    render() {
        const {datos, numPaginas, cargandoDatos, paginaActual} =  this.state;
        const {id, columnas, elementoConfig, nivel, onSelectedRow, onDeleteRow, /*showPaginador,*/ paginacionTipo, showBuscador,
            elementoSeleccionado, valorBuscador, onValorBuscadorCambiado,
            editable, onRowModificada, onNewRow, tipoGrid,
            cargandoListasElementosCombos, listasElementosCombos,
            usuarioCodigo, ifid, usuario,
            mostrarFilaActiva, onAcceptedRow,
            onDatosModificados,
            estilizadorRow, estilo,
            urlServicioRestful, usarFiltros35,
            funcRefreshData,
            mostrarModificar, onModificar,
            mostrarEliminar, onEliminar,
            desdeMovil,
            mostrarChecksSeleccion, onSelectedRowsChanged,
        } = this.props;

        let paginacionTipoReal= paginacionTipo ? paginacionTipo : PAGINACIONTIPO_NORMAL;
        let mostrarPaginador= numPaginas > 1 && paginacionTipoReal === PAGINACIONTIPO_NORMAL;

        //console.log("GRIDPAGINADO - RENDER");
        //console.log("valorBuscador: ", valorBuscador);
        //console.log("columnas: ", columnas);
        //console.log("urlServicioRestful: ", urlServicioRestful);
        //console.log("paginacionTipo: ", paginacionTipo);
        //console.log("paginacionTipoReal: ", paginacionTipoReal);
        //console.log("numPAginas: ", numPaginas);
        //console.log("mostrarPaginador: ", mostrarPaginador);
        //console.log("ifid: ", ifid);
        //console.log("tipoGrid: ", tipoGrid);
        //console.log("Datos: ", datos);
        //console.log("mostrarFilaActiva: ", mostrarFilaActiva);
        //console.log("estilizadorRow");
        //console.log(estilizadorRow);

        return (
            <div>
                { (cargandoDatos || cargandoListasElementosCombos) &&  <Spinner intent={Intent.PRIMARY} size={50} /> }
                { !cargandoDatos && !cargandoListasElementosCombos &&
                    <div style={{margin: 5}} >
                        {(!tipoGrid || tipoGrid !== "reactdatagrid") &&
                        <Grid columnas={columnas} nivel={nivel} datos={datos}
                              onSelectedRow={onSelectedRow}
                              onDeleteRow={onDeleteRow}
                              ordenable={true}
                              showBuscador={showBuscador}
                              elementoSeleccionado={elementoSeleccionado}
                              valorBuscador={valorBuscador}
                              onValorBuscadorCambiado={onValorBuscadorCambiado}
                              //usuarioCodigo={usuarioCodigo}
                              ifid={ifid}
                              ref={this.refGrid}
                              usuario={usuario}

                              editable={editable}
                              onRowModificada={onRowModificada}
                              onNewRow={onNewRow}

                              onAcceptedRow={onAcceptedRow}
                              onDatosModificados= {onDatosModificados}
                              />
                        }
                        {tipoGrid && tipoGrid === "reactdatagrid" &&
                        <GridRDG id={id}
                                 columnas={columnas} datos={datos}
                                 elementoConfig={elementoConfig}
                                 onSelectedRow={onSelectedRow}
                                 ordenable={true}

                                 estilo={estilo}
                                //showBuscador={showBuscador}
                                //usuarioCodigo={usuarioCodigo}
                                 ref={this.refGrid}
                                 wrappedComponentRef={this.refGrid}

                                 ifid={ifid}
                                 usuario={usuario}


                                 rowKey={"codigo"}

                                 elementoSeleccionado={elementoSeleccionado}
                                 estilizadorRow={estilizadorRow}
                                 mostrarFilaActiva={mostrarFilaActiva}

                                 editable={editable}
                                 onRowModificada={onRowModificada}

                                 urlServicioRestful={urlServicioRestful}
                                 usarFiltros35={usarFiltros35}

                                 funcRefreshData={funcRefreshData}
                                 onValorBuscadorCambiado={onValorBuscadorCambiado}
                                 valorBuscador={valorBuscador}

                                 mostrarModificar={mostrarModificar}
                                 onModificar={onModificar}
                                 mostrarEliminar={mostrarEliminar}
                                 onEliminar={onEliminar}

                                 desdeMovil={desdeMovil}

                                 mostrarChecksSeleccion= {mostrarChecksSeleccion}
                                 onSelectedRowsChanged= {onSelectedRowsChanged}
                        />
                        }
                        { mostrarPaginador &&
                            <ReactPaginate
                                initialPage={paginaActual}
                                previousLabel={'anterior'}
                                nextLabel={'siguiente'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={numPaginas}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                pageClassName={"pagination-page"}
                                previousClassName={"pagination-page"}
                                nextClassName={"pagination-page"}
                                activeClassName={'pagination-active'}
                                pageLinkClassName={"pagination-link"}
                            />
                        }


                    </div>
                }

            </div>
        );
    }
}

/*


 */
GridPaginado.propTypes = {
    id: PropTypes.string,
    columnas: PropTypes.array.isRequired,
    nivel: PropTypes.object,
    datos: PropTypes.array.isRequired,
    loadedTodasPaginas: PropTypes.bool,
    paginacionTipo: PropTypes.string,
    onSelectedRow: PropTypes.func,
    showBuscador: PropTypes.bool,
    elementoSeleccionado: PropTypes.object,
    valorBuscador: PropTypes.string,
    onValorBuscadorCambiado: PropTypes.func,
    editable: PropTypes.bool,
    onRowModificada: PropTypes.func,
    onNewRow: PropTypes.func,
    tipoGrid: PropTypes.string,
    elementoConfig: PropTypes.object,
    listasElementosCombos: PropTypes.object,
    cargandoListasElementosCombos: PropTypes.bool,

    usuario: PropTypes.object,

    mostrarFilaActiva: PropTypes.bool,
    onAcceptedRow: PropTypes.func,

    onDatosModificados: PropTypes.func,
    estilizadorRow: PropTypes.func,
    estilo: PropTypes.object,

    urlServicioRestful: PropTypes.string,
    usarFiltros35: PropTypes.bool,
    funcRefreshData: PropTypes.func,

    mostrarModificar: PropTypes.bool,
    onModificar: PropTypes.func,
    mostrarEliminar: PropTypes.bool,
    onEliminar: PropTypes.func,

    desdeMovil: PropTypes.bool,

    mostrarChecksSeleccion: PropTypes.bool,
    onSelectedRowsChanged: PropTypes.func,
}

export default GridPaginado
